/** Names the message the service worker sends when a notification is tapped. */
const NAVIGATE_MESSAGE = "slorg:navigate";

/**
 * Routes the app when the service worker reports a notification tap.
 *
 * The worker focuses this window and says where to go rather than navigating it
 * itself, since a navigation from outside reloads the app and takes the editor
 * and the open documents with it. Routing here goes through the router, so
 * anything guarding a screen gets its say.
 * @param {(url: string) => void} navigate The router's navigate function
 * @returns {() => void} Stops listening
 */
export function listenForPushNavigation(navigate) {
  if (!("serviceWorker" in navigator)) return () => {};

  const handleMessage = (event) => {
    const { type, url } = event.data || {};

    if (type === NAVIGATE_MESSAGE && url) navigate(url);
  };

  navigator.serviceWorker.addEventListener("message", handleMessage);

  return () =>
    navigator.serviceWorker.removeEventListener("message", handleMessage);
}
